import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';

import Flyout from 'Components/UI/Flyout';
import LoadingIndicator from 'Components/UI/LoadingIndicator';

import MetaFormInline from './Components/MetaFormInline';

const styles = theme => ({
  root: {},
  form: {
    padding: theme.spacing(0),
  },
  header: {},
  formGroup: {},
});

function MetaCollectionFormDrawer({
  className,
  classes,
  collection,
  footer,
  header,
  loading,
  onClose,
  onDelete,
  onFailure,
  onSubmit,
  confirmDeleteMessage,
  metaOverrideSet,
  FormProps,
  ...rest
}) {
  const resourceList = loading ? [] : collection.resources().list();
  const resourceCount = resourceList.length;

  return (
    <Flyout onClose={onClose} disableRestoreFocus disableEnforceFocus {...rest}>
      {loading ? (
        <LoadingIndicator />
      ) : (
        <>
          {header}
          <div className={classNames(classes.formGroup, className)}>
            {resourceList.map((resource, i) => (
              <MetaFormInline
                className={classNames(classes.form, {
                  [classes.firstForm]: i === 0,
                  [classes.lastForm]: i === resourceCount - 1,
                })}
                key={`${resource.id()}-${i}`} // eslint-disable-line react/no-array-index-key
                resource={resource}
                onDelete={onDelete}
                onFailure={onFailure}
                onSubmit={onSubmit}
                confirmDeleteMessage={confirmDeleteMessage}
                metaOverrideSet={metaOverrideSet}
                {...FormProps}
              />
            ))}
          </div>
          {footer}
        </>
      )}
    </Flyout>
  );
}

MetaCollectionFormDrawer.defaultProps = {
  className: '',
  collection: null,
  footer: null,
  header: null,
  loading: false,
  onDelete: null,
  onFailure: null,
  onSubmit: null,
  FormProps: {},
  confirmDeleteMessage: null,
  metaOverrideSet: null,
};

MetaCollectionFormDrawer.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  collection: PropTypes.object,
  footer: PropTypes.node,
  header: PropTypes.node,
  loading: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onDelete: PropTypes.func,
  onFailure: PropTypes.func,
  onSubmit: PropTypes.func,
  FormProps: PropTypes.object,
  confirmDeleteMessage: PropTypes.string,
  metaOverrideSet: PropTypes.object,
};

export default withStyles(styles)(MetaCollectionFormDrawer);
